import React from 'react'
import PropTypes from 'prop-types'

const SummaryPrice = ({ totalExclVat, vat, shipping, total, currencySign, totalVatMsg, shippingMsg, vatMsg, totalMsg }) => (
  <div className='summary_cart'>
    <div className='row'>
      <div className='col-md-7' />
      <div className='col col-md-3 text-left'>{totalVatMsg}</div>
      <div className='col col-md-2 text-right'>{totalExclVat} {currencySign}</div>
    </div>
    <div className={'row ' + (!shipping ? 'd-none' : 'd-show')}>
      <div className='col-md-7' />
      <div className='col col-md-3 text-left'>{shippingMsg}</div>
      <div className='col col-md-2 text-right'>{shipping} {currencySign}</div>
    </div>
    <div className='row'>
      <div className='col-md-7' />
      <div className='col col-md-3 text-left'>{vatMsg}</div>
      <div className='col col-md-2 text-right'>{vat} {currencySign}</div>
    </div>
    <div className='row'>
      <div className='col-md-7' />
      <div className='col col-md-3 text-left'><b>{totalMsg}</b></div>
      <div className='col col-md-2 text-right'><b>{total} {currencySign}</b></div>
    </div>
  </div>
)

SummaryPrice.propTypes = {
  totalExclVat: PropTypes.number.isRequired,
  vat: PropTypes.number.isRequired,
  shipping: PropTypes.number,
  total: PropTypes.number.isRequired,
  currencySign: PropTypes.string,
  totalVatMsg: PropTypes.string,
  shippingMsg: PropTypes.string,
  vatMsg: PropTypes.string,
  totalMsg: PropTypes.string
}

export default SummaryPrice



// WEBPACK FOOTER //
// ./src/molecules/components/SummaryPrice.js